import React from 'react';
import { LendiMemberType } from '../../../../../twilio';
import { BotWrapper, DisplayWrapper, FooterAvatarWrapper } from './style';
import { BotIcon } from './ThemedBotIcon';
import { CustomerAvatar } from './CustomerAvatar';
import { BrokerAvatar } from './BrokerAvatar';
var Avatar = function (_a) {
    var member = _a.member, isFooter = _a.isFooter;
    var _b = member || {}, _c = _b.firstName, firstName = _c === void 0 ? '' : _c, _d = _b.lastName, lastName = _d === void 0 ? '' : _d, _e = _b.type, type = _e === void 0 ? LendiMemberType.CUSTOMER : _e;
    var initials = firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
    var insideAvartar = function () {
        switch (type) {
            case LendiMemberType.CUSTOMER:
                return React.createElement(CustomerAvatar, { initials: initials, isFooter: isFooter });
            case LendiMemberType.TEAM:
                return React.createElement(BrokerAvatar, { profilePictureURL: member === null || member === void 0 ? void 0 : member.profilePictureURL, isFooter: isFooter });
            case LendiMemberType.BOT:
                return (React.createElement(BotWrapper, { isFooter: isFooter },
                    React.createElement(BotIcon, null)));
            default:
                return React.createElement(React.Fragment, null);
        }
    };
    return (React.createElement(React.Fragment, null, type === LendiMemberType.BOT ? (insideAvartar()) : isFooter === true ? (React.createElement(FooterAvatarWrapper, null, insideAvartar())) : (React.createElement(DisplayWrapper, null, insideAvartar()))));
};
export default Avatar;
//# sourceMappingURL=index.js.map